import { GetStaticProps, NextPage } from "next";
import ContactsView from "@components/views/ContactsView";
import Head from "next/head";

const ContactsPage: NextPage = () => {
	return (
		<>
			<Head>
				<title>Контактная информация — Selfschool</title>
				<meta
					name="description"
					content="Образовательная онлайн-платформа Selfschool. Наши специалисты ответят на любые вопросы, связанные с платформой. От обучения и преподавания до сотрудничества."
				/>
			</Head>
			<ContactsView />
		</>
	);
};

export const getStaticProps: GetStaticProps = async () => {
	return {
		props: {},
	};
};

export default ContactsPage;
